// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Y6-z","displaySixCardTiles":"Z6-z"};